import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import Input from '../../Form/Field/Input.jsx';
import Select from '../../Form/Field/Select.jsx';
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';
import Date from '../../Form/Field/Date.jsx';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';

import conf from '../../../conf.js';
import validate from './validate.js';

import './ProfilePresentationForm.scss';

export const name = 'ProfilePresentationForm';

class ProfilePresentationForm extends Component {
  static propTypes = {
    counter: PropTypes.number,
  }

  static defaultProps = {
    counter: 1300
  }

  constructor(props) {
    super(props);
    this.state = {
      counter: props.counter - (props.initialValues.freelance.summary ? props.initialValues.freelance.summary.length : 0),
    }
  }

  handleSummaryChange = (e) => {
    const _c = this.props.counter - e.target.value.length;
    this.setState({
      counter: _c < 0 ? 0 : _c,
    });
  }

  limiter = (value) => {
    if(value.length > this.props.counter) {
      return value.substring(0, this.props.counter);
    }

    return value
  }

  render() {
    return (
      <div id={name}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <h4 id="pres-perso" className="text-center my-5 mb-4">Informations personnelles</h4>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Prénom"
                name="user.firstname"
                placeholder="John..."
                type="text"
                component={Input}
              />
            </div>
            <div className="col-md-6">
              <Field
                label="Nom"
                name="user.lastname"
                placeholder="Doe..."
                type="text"
                component={Input}
              />
            </div>
          </div>
          {this.props.isAdmin ?
            <div className="row">
              <div className="col-md-6">
                <Field
                  label="E-mail"
                  name="user.email"
                  placeholder=""
                  type="text"
                  component={Input}
                />
              </div>
            </div>
            : ''
          }
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Numéro de téléphone"
                name="user.tel"
                placeholder="+33612345678"
                type="tel"
                component={Input}
              />
            </div>
            <div className="col-md-6">
              <Field
                label="Date de naissance"
                name="user.date_of_birth"
                placeholder="jj/mm/aaaa"
                type="text"
                component={Date}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Nom de votre entreprise"
                name="user.company"
                type="text"
                component={Input}
              />
            </div>
            <div className="col-md-6">
              <Field
                label="Type d'entreprise"
                name="user.company_type"
                type="select"
                component={Select}
              >
                {Object.keys(conf.companyTypes).map((key) => (
                  <option value={key} key={key}>{conf.companyTypes[key].profilValue}</option>
                ))}
              </Field>
            </div>
          </div>

          <h4 id="pres-pro" className="text-center mt-5 mb-4">Présentation professionnelle</h4>
          <div className="row">
            <div className="col-md-12">
              <Field
                label="Titre de votre fiche"
                placeholder={this.props?.currentUniverse?.title_placeholder ?? ''}
                name="freelance.title"
                type="text"
                component={Input}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Field
                label="Décrivez vous et vos attentes, en quelques lignes"
                name="freelance.summary"
                component={Input}
                type="textarea"
                onChange={this.handleSummaryChange}
                counter={this.state.counter}
                normalize={this.limiter}
              />
            </div>
          </div>

          <h4 id="pres-linkedin" className="text-center mt-5 mb-4">Linkedin</h4>
          <div className="row">
            <div className="col-md-12">
              <Field
                label="Lien de votre profil LinkedIn"
                name="user.linkedin_url"
                placeholder="https://www.linkedin.com/in/"
                type="text"
                component={Input}/>
            </div>
            <div className="col-md-12">
              <p className="text-center">
                <a href="https://www.linkedin.com/help/linkedin/answer/49933?lang=fr" target="_blank"
                  rel="noopener noreferrer">
                Comment trouver l’URL de votre profil LinkedIn ?
                </a>
              </p>
            </div>
          </div>

          <input className="d-none" type="submit"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    currentUniverse: state.universe.currentUniverse,
  })
)(reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name)
})(ProfilePresentationForm))
